import { banners as EnUsBanner } from '../en-us/banners';
import { AgResourceLanguage } from '../types';

export const banners: AgResourceLanguage['banners'] = {
  ...EnUsBanner,
  gift: {
    ...EnUsBanner.gift,
    title: 'Schicke eine Überraschung an Familie und Freunde',
    description: 'Lass deine Liebsten AG1 doch einfach mal probieren.'
  },
  stockBanner:
    'Es sieht leider so aus, als wäre eines deiner Abos nicht vorrätig. Du kannst das Abo auf seiner Abo-Seite verwalten. Das nächste Versanddatum ist',
  upcomingOrderBanner: {
    preparing: 'In Bearbeitung',
    shipped: 'Versendet',
    delivered: 'Geliefert',
    preparingDescription: 'Wir bereiten deine Bestellung vor.',
    shippedDescription: 'Deine Bestellung ist auf dem Weg zu dir.',
    deliveredDescription: 'Stark! Du hast dein AG1 erhalten.',
    orderDetailsLink: 'Bestelldetails ansehen',
    trackingLink: 'Sendung verfolgen'
  },
  offerSoldOut: 'Dieses Angebot ist ausverkauft',
  offerVariantsSoldOut: {
    soldOut_one: '{{soldOutProducts}} ist ausverkauft',
    soldOut_other: '{{soldOutProducts}} sind ausverkauft'
  }
};
